/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { 
  Search, MapPin, Compass, 
  Snowflake, Heart, Star, Plane, 
  Hotel, Car, ArrowRight, X, Sparkles, AlertCircle, Menu, Flame,
  Mail, CheckCircle2, Loader2
} from 'lucide-react';
import { HelmetProvider, Helmet } from 'react-helmet-async';

// ==========================================
// 💰 YOUR AFFILIATE LINKS 💰
// ==========================================
const EXPEDIA_LINK = "https://expedia.com/affiliate/3NJJPcX";
const TRIP_COM_LINK = "https://www.trip.com/things-to-do/?Allianceid=4089639&SID=32000200&trip_sub1=&trip_sub3=D16514717";
const FLIGHTS_LINK = "https://aviasales.tpm.li/xxdN6SZh"; 

const DEALS = [
  { id: 1, title: "Find the Best Canadian Hotels", provider: "Expedia Partner", icon: Hotel, price: "Search Deals", link: EXPEDIA_LINK },
  { id: 2, title: "Book Local Experiences & Tours", provider: "Trip.com Partner", icon: Car, price: "Explore", link: TRIP_COM_LINK },
  { id: 3, title: "Cheap Flights Across Canada", provider: "Aviasales Partner", icon: Plane, price: "Search Flights", link: FLIGHTS_LINK },
];

const FALLBACK_DESTINATIONS = [
  {
    id: 1, title: "Winnipeg Winter Wonders", category: "Hidden Gems",
    image: "https://images.unsplash.com/photo-1542475453-61ce387cb71a?auto=format&fit=crop&w=800&q=80",
    rating: 4.8, reviews: 124, 
    description: "Discover the Forks on skates, world-class thermotherapy, and local culinary secrets.",
    content: "<p>This is a placeholder article. The network is currently syncing with the main database.</p>"
  }
];

export default function CanadianLogsApp() {
  const [activeTab, setActiveTab] = useState('home');
  const [destinations, setDestinations] = useState([]);
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [selectedPost, setSelectedPost] = useState(null); 

  // Fetch from the WordPress Backdoor
  useEffect(() => {
    fetch('https://admin.canadianlogs.com/wp-json/wp/v2/posts?_embed&per_page=12')
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        const formattedPosts = data.map(post => {
          const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?auto=format&fit=crop&w=800&q=80';
          const categoryName = post._embedded?.['wp:term']?.[0]?.[0]?.name || "Travel Guide";
          const seoData = post.pragma_seo_data || {};
          
          return {
            id: post.id,
            title: post.title.rendered,
            category: categoryName,
            image: imageUrl,
            rating: 4.9, 
            reviews: (post.id % 50) + 12, 
            description: post.excerpt.rendered,
            content: post.content.rendered, 
            seoTitle: seoData.seo_title || post.title.rendered.replace(/<[^>]+>/g, ''), // Strip HTML tags for SEO
            seoDesc: seoData.seo_desc || "Explore authentic local Canadian travel guides.",
            socialImage: seoData.social_image || imageUrl
          };
        });
        setDestinations(formattedPosts);
        setLoadingPosts(false);
      })
      .catch(error => {
        console.warn("Loading fallback data.", error.message);
        setDestinations(FALLBACK_DESTINATIONS);
        setLoadingPosts(false);
      });
  }, []);

  return (
    <HelmetProvider>
      <div className="min-h-screen bg-slate-50 font-sans text-slate-800 flex flex-col">
        
        {/* GLOBAL SEO - Only shows if we are NOT on an article page */}
        {activeTab !== 'article' && (
          <Helmet>
            <title>Canadian Logs | Local Travel Guides & Epic Deals</title>
            <meta name="description" content="Ditch the tourist traps. Discover hidden gems, authentic Canadian travel guides, and unlock massive travel deals instantly." />
            <meta property="og:title" content="Canadian Logs | Local Travel Guides & Deals" />
            <meta property="og:description" content="Discover hidden gems and authentic Canadian travel deals powered by AI." />
            <meta property="og:type" content="website" />
          </Helmet>
        )}

        <Navbar setActiveTab={setActiveTab} activeTab={activeTab} />
        
        <main className="pt-16 flex-grow">
          {activeTab === 'home' && <HomeView setActiveTab={setActiveTab} destinations={destinations} loadingPosts={loadingPosts} setSelectedPost={setSelectedPost} />}
          {activeTab === 'destinations' && <DestinationsView setActiveTab={setActiveTab} destinations={destinations} loadingPosts={loadingPosts} setSelectedPost={setSelectedPost} />}
          {activeTab === 'ai-planner' && <AiPlannerView />}
          {activeTab === 'article' && selectedPost && <ArticleView post={selectedPost} setActiveTab={setActiveTab} />}
        </main>

        <Footer setActiveTab={setActiveTab} />
      </div>
    </HelmetProvider>
  );
}

// ==========================================
// 📢 CUSTOM AD BANNER COMPONENT 📢
// ==========================================
function AdBanner() {
  const adCode = `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          body { margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; background: transparent; }
        </style>
      </head>
      <body>
        <script type="text/javascript">
          atOptions = {
            'key' : 'c857781b810c5cbdc6eedcd5994a7b6b',
            'format' : 'iframe',
            'height' : 90,
            'width' : 728,
            'params' : {}
          };
        </script>
        <script type="text/javascript" src="https://www.highperformanceformat.com/c857781b810c5cbdc6eedcd5994a7b6b/invoke.js"></script>
      </body>
    </html>
  `;

  return (
    <div className="w-full bg-slate-100 border border-slate-200 rounded-xl p-4 my-10 flex flex-col items-center justify-center min-h-[120px] text-center shadow-inner overflow-hidden">
      <span className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Advertisement</span>
      <iframe 
        srcDoc={adCode} 
        width="728" 
        height="90" 
        frameBorder="0" 
        scrolling="no" 
        title="sponsor-banner"
        style={{ maxWidth: '100%', border: 'none' }}
      />
    </div>
  );
}

// --- COMPONENTS ---

// 📖 FULL ARTICLE VIEWER WITH DYNAMIC PRAGMA SEO 📖
function ArticleView({ post, setActiveTab }) {
  // Check if we have an explicitly set SEO Title from Pragma, otherwise build one
  const documentTitle = post.seoTitle && post.seoTitle !== post.title 
    ? post.seoTitle 
    : `${post.title.replace(/<[^>]+>/g, '')} | Canadian Logs Deals`;

  return (
    <div className="animate-in fade-in max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      
      {/* 🔥 THIS IS WHERE THE MAGIC HAPPENS! Injecting Pragma SEO into Google 🔥 */}
      <Helmet>
        <title>{documentTitle}</title>
        <meta name="description" content={post.seoDesc} />
        <meta property="og:title" content={documentTitle} />
        <meta property="og:description" content={post.seoDesc} />
        <meta property="og:image" content={post.socialImage} />
        <meta property="og:type" content="article" />
      </Helmet>

      <button 
        onClick={() => { setActiveTab('home'); window.scrollTo(0,0); }} 
        className="flex items-center text-blue-600 hover:text-blue-800 mb-8 font-semibold transition"
      >
        <ArrowRight className="mr-2 rotate-180" size={16} /> Back to Guides
      </button>
      
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-slate-100">
        <div className="h-64 md:h-96 w-full relative">
          <img src={post.image} alt="Cover" className="w-full h-full object-cover" />
          <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold text-slate-800 shadow">
            {post.category}
          </div>
        </div>
        
        <div className="p-8 md:p-12">
          <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6" dangerouslySetInnerHTML={{ __html: post.title }}></h1>
          
          <div className="flex items-center text-sm text-slate-500 mb-10 pb-10 border-b border-slate-100">
            <Star size={18} className="text-amber-400 fill-amber-400 mr-1" />
            <span className="font-bold text-slate-700 mr-2">{post.rating}</span>
            <span>({post.reviews} local reviews)</span>
          </div>
          
          <div className="wp-article-content text-lg text-slate-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: post.content }}></div>
          
          <style dangerouslySetInnerHTML={{__html: `
            .wp-article-content p { margin-bottom: 1.5em; }
            .wp-article-content h2 { font-size: 1.875rem; font-weight: 800; color: #0f172a; margin-top: 2em; margin-bottom: 0.75em; }
            .wp-article-content h3 { font-size: 1.5rem; font-weight: 700; color: #1e293b; margin-top: 1.5em; margin-bottom: 0.75em; }
            .wp-article-content a { color: #2563eb; text-decoration: underline; font-weight: 600; }
            .wp-article-content ul { list-style-type: disc; padding-left: 1.5em; margin-bottom: 1.5em; }
            .wp-article-content ol { list-style-type: decimal; padding-left: 1.5em; margin-bottom: 1.5em; }
            .wp-article-content img { border-radius: 0.75rem; margin: 2em 0; max-width: 100%; height: auto; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1); }
            .wp-article-content blockquote { border-left: 4px solid #3b82f6; padding-left: 1em; font-style: italic; color: #475569; margin: 1.5em 0; background: #f8fafc; padding: 1em; border-radius: 0 0.5rem 0.5rem 0;}
          `}} />

        </div>
      </div>
    </div>
  );
}


function Navbar({ setActiveTab, activeTab }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavClick = (tab) => {
    setActiveTab(tab);
    setIsMobileMenuOpen(false);
  }

  const scrollToDeals = () => {
    setActiveTab('home');
    setIsMobileMenuOpen(false);
    setTimeout(() => {
      const dealsSection = document.getElementById('deals-section');
      if (dealsSection) dealsSection.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  return (
    <nav className="fixed top-0 w-full bg-white/90 backdrop-blur-md shadow-sm z-50 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center cursor-pointer group" onClick={() => handleNavClick('home')}>
            <div className="bg-blue-600 text-white p-2 rounded-lg mr-2 group-hover:bg-blue-700 transition">
              <Snowflake size={24} />
            </div>
            <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-cyan-600">
              Canadian Logs
            </span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <NavLink active={activeTab === 'home'} onClick={() => handleNavClick('home')}>Explore</NavLink>
            <NavLink active={activeTab === 'destinations'} onClick={() => handleNavClick('destinations')}>Destinations</NavLink>
            
            {/* NEW HOT DEALS NAV BUTTON */}
            <button 
              onClick={scrollToDeals}
              className="flex items-center space-x-1 text-red-600 font-bold hover:text-red-700 transition animate-pulse"
            >
              <Flame size={18} />
              <span>HOT DEALS</span>
            </button>

            <button 
              onClick={() => handleNavClick('ai-planner')}
              className="flex items-center space-x-1 bg-indigo-50 text-indigo-700 px-4 py-2 rounded-full font-medium hover:bg-indigo-100 transition shadow-sm"
            >
              <Sparkles size={16} />
              <span>AI Trip Planner</span>
            </button>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-600 hover:text-blue-600">
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-b border-slate-200 px-4 pt-2 pb-4 space-y-2 shadow-lg absolute w-full">
          <button onClick={() => handleNavClick('home')} className={`block w-full text-left px-3 py-2 rounded-md font-medium ${activeTab === 'home' ? 'bg-blue-50 text-blue-600' : 'text-slate-600'}`}>Explore</button>
          <button onClick={() => handleNavClick('destinations')} className={`block w-full text-left px-3 py-2 rounded-md font-medium ${activeTab === 'destinations' ? 'bg-blue-50 text-blue-600' : 'text-slate-600'}`}>Destinations</button>
          <button onClick={scrollToDeals} className="flex items-center w-full px-3 py-2 mt-2 bg-red-50 text-red-600 rounded-md font-bold">
            <Flame size={16} className="mr-2" /> HOT DEALS
          </button>
          <button onClick={() => handleNavClick('ai-planner')} className="flex items-center w-full px-3 py-2 mt-2 bg-indigo-50 text-indigo-700 rounded-md font-medium">
            <Sparkles size={16} className="mr-2" /> AI Trip Planner
          </button>
        </div>
      )}
    </nav>
  );
}

function NavLink({ children, active, onClick }) {
  return (
    <button onClick={onClick} className={`font-medium transition ${active ? 'text-blue-600 border-b-2 border-blue-600' : 'text-slate-600 hover:text-blue-600'}`}>
      {children}
    </button>
  );
}

function HomeView({ setActiveTab, destinations, loadingPosts, setSelectedPost }) {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const uniqueCategories = ['All', ...new Set(destinations.map(dest => dest.category))];
  const filteredDestinations = selectedCategory === 'All' ? destinations : destinations.filter(dest => dest.category === selectedCategory);
  const featuredDestinations = filteredDestinations.slice(0, 6); 

  const handleCardClick = (dest) => {
    setSelectedPost(dest);
    setActiveTab('article');
    window.scrollTo(0,0);
  }

  return (
    <div className="animate-in fade-in duration-500">
      <div className="relative bg-slate-900 overflow-hidden">
        <div className="absolute inset-0">
          <img className="w-full h-full object-cover opacity-40" src="https://images.unsplash.com/photo-1503614472-8c93d56e92ce?auto=format&fit=crop&w=1920&q=80" alt="Canadian Rockies" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 flex flex-col items-center text-center">
          <span className="text-yellow-400 font-bold tracking-wider uppercase text-sm mb-4 bg-black/50 px-4 py-1 rounded-full border border-yellow-400/30">🔥 Unlocking Canada's Best Deals</span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6">
            Travel More. <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-yellow-400">Spend Less.</span>
          </h1>
          <p className="text-xl text-slate-300 max-w-2xl mb-10">
            Ditch the tourist traps. Get hyper-local itineraries, exclusive budget deals, and hidden gems curated by locals.
          </p>
          
          <div className="w-full max-w-4xl bg-white p-2 rounded-2xl md:rounded-full shadow-2xl flex flex-col md:flex-row gap-2">
            <div className="flex-1 flex items-center px-4 py-2 border-b md:border-b-0 md:border-r border-slate-200">
              <MapPin className="text-slate-400 mr-3" />
              <input type="text" placeholder="Where to? (e.g., Winnipeg)" className="w-full outline-none text-slate-700 bg-transparent" />
            </div>
            <button onClick={() => setActiveTab('ai-planner')} className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-xl md:rounded-full font-bold transition flex items-center justify-center">
              <Sparkles className="mr-2" size={20} /> AI Planner
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        <div className="flex overflow-x-auto pb-4 gap-4 mb-12 hide-scrollbar">
          {uniqueCategories.map((cat) => (
            <button 
              key={cat} 
              onClick={() => setSelectedCategory(cat)} 
              className={`px-6 py-3 border rounded-full font-medium transition whitespace-nowrap ${
                selectedCategory === cat 
                  ? 'bg-blue-600 text-white border-blue-600 shadow-md' 
                  : 'bg-white border-slate-200 text-slate-700 hover:border-blue-500 hover:text-blue-600'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div id="deals-section" className="mb-12 scroll-mt-24">
          <div className="flex items-center mb-6">
            <Flame className="text-red-600 mr-2" size={28} />
            <h2 className="text-2xl font-black text-slate-900 uppercase">Today's Hot Deals</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {DEALS.map(deal => {
              const Icon = deal.icon;
              return (
                <a href={deal.link} target="_blank" rel="noopener noreferrer" key={deal.id} className="border-2 border-red-100 rounded-xl p-5 hover:border-red-400 hover:bg-red-50/50 transition cursor-pointer flex items-center justify-between shadow-sm relative overflow-hidden group">
                  <div className="absolute top-0 right-0 bg-red-600 text-white text-[10px] font-bold px-2 py-1 rounded-bl-lg">PROMO</div>
                  <div className="flex items-center">
                    <div className="bg-red-100 group-hover:bg-red-200 transition p-3 rounded-lg text-red-600 mr-4"><Icon size={24} /></div>
                    <div>
                      <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">{deal.provider}</p>
                      <h4 className="font-bold text-slate-900">{deal.title}</h4>
                    </div>
                  </div>
                  <div className="text-right ml-4">
                    <span className="block text-sm font-extrabold text-red-600">{deal.price} <ArrowRight size={14} className="inline ml-1"/></span>
                  </div>
                </a>
              )
            })}
          </div>
        </div>

        {/* 📢 AD BANNER RENDERS HERE 📢 */}
        <AdBanner />

        <div className="flex justify-between items-end mb-8 mt-12">
          <div>
            <h2 className="text-3xl font-bold text-slate-900">Featured Local Guides</h2>
            <p className="text-slate-500 mt-2">Authentic experiences straight from our live blog.</p>
          </div>
          <button onClick={() => setActiveTab('destinations')} className="text-blue-600 font-semibold hover:underline hidden md:flex items-center">
            View all guides <ArrowRight size={16} className="ml-1" />
          </button>
        </div>

        {loadingPosts ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
             {[1, 2, 3].map(skeleton => (
                <div key={skeleton} className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden h-96 flex flex-col animate-pulse">
                  <div className="bg-slate-200 h-56 w-full"></div>
                  <div className="p-6 space-y-4">
                    <div className="h-6 bg-slate-200 rounded w-3/4"></div>
                  </div>
                </div>
             ))}
          </div>
        ) : featuredDestinations.length === 0 ? (
          <div className="bg-white p-8 rounded-2xl border border-slate-100 text-center mb-16 shadow-sm">
            <h3 className="text-xl font-bold text-slate-800 mb-2">No guides found.</h3>
            <p className="text-slate-500">Check back later for articles in this category!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {featuredDestinations.map(dest => (
              <div 
                key={dest.id} 
                onClick={() => handleCardClick(dest)}
                className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-xl hover:border-blue-200 transition group cursor-pointer flex flex-col"
              >
                <div className="relative h-56 overflow-hidden shrink-0">
                  <img src={dest.image} alt="Featured" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-slate-800 shadow">
                    {dest.category}
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition" dangerouslySetInnerHTML={{ __html: dest.title }}></h3>
                  <div className="flex items-center text-sm text-slate-500 mb-4 shrink-0">
                    <Star size={16} className="text-amber-400 fill-amber-400 mr-1" />
                    <span className="font-bold text-slate-700 mr-1">{dest.rating}</span>
                    <span>({dest.reviews} reviews)</span>
                  </div>
                  <div className="text-slate-600 text-sm line-clamp-3" dangerouslySetInnerHTML={{ __html: dest.description }}></div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* 📢 VIATOR "DEALS EXPLOSION" CUSTOM BANNER 📢 */}
        <div className="bg-red-600 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden flex flex-col items-center text-center mb-16 transform transition hover:scale-[1.01] border-4 border-yellow-400 group">
          {/* Animated Background Elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
            <div className="absolute -top-20 -left-20 w-64 h-64 bg-yellow-500 rounded-full mix-blend-screen filter blur-3xl opacity-50 animate-pulse"></div>
            <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-orange-500 rounded-full mix-blend-screen filter blur-3xl opacity-50 animate-pulse" style={{animationDelay: '1s'}}></div>
          </div>
          
          <div className="relative z-10 flex flex-col items-center">
            <div className="bg-yellow-400 text-red-900 font-black text-sm md:text-base px-4 py-1 rounded-full mb-4 uppercase tracking-widest shadow-lg transform -rotate-2">
              Limited Time Partner Offer
            </div>
            
            <h2 className="text-4xl md:text-6xl font-black mb-4 tracking-tight uppercase italic flex items-center justify-center gap-2 drop-shadow-lg">
              <Flame className="text-yellow-400 hidden md:block" size={48} /> 
              MASSIVE NIAGARA DEALS 
              <Flame className="text-yellow-400 hidden md:block" size={48} />
            </h2>
            
            <p className="text-xl md:text-2xl font-bold mb-8 max-w-2xl text-red-50 drop-shadow-md">
              Don't pay full price at the falls. Get exclusive access to heavily discounted Niagara Falls tours, boat cruises, and local experiences.
            </p>
            
            <a 
              href="https://www.viator.com/Niagara-Falls-and-Around/d773-ttd?pid=P00300062&mcid=42383&medium=link&medium_version=selector&campaign=Niagara-Falls-Tours-2026"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-400 text-red-900 px-8 py-5 md:px-12 md:py-6 rounded-full font-black text-xl md:text-3xl hover:bg-yellow-300 transition-all shadow-[0_0_30px_rgba(250,204,21,0.5)] group-hover:shadow-[0_0_50px_rgba(250,204,21,0.8)] group-hover:-translate-y-1 flex items-center uppercase"
            >
              Unlock Niagara Deals <ArrowRight className="ml-3 font-black" size={32} />
            </a>
          </div>
        </div>

        {/* 📢 NEWSLETTER / EMAIL CAPTURE: "THE WEEKLY DEAL DROP" 📢 */}
        <NewsletterSignup />

        <div className="bg-gradient-to-br from-indigo-900 to-blue-900 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden flex flex-col md:flex-row items-center mb-16">
          <div className="absolute right-0 top-0 opacity-10 pointer-events-none">
            <Sparkles size={200} />
          </div>
          <div className="md:w-2/3 relative z-10">
            <div className="inline-flex items-center space-x-2 bg-indigo-800/50 rounded-full px-4 py-1.5 mb-6 border border-indigo-500/30">
              <Sparkles size={16} className="text-indigo-300" />
              <span className="text-sm font-semibold text-indigo-200">New Feature</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4">Plan a perfect trip in seconds.</h2>
            <p className="text-indigo-200 text-lg mb-8 max-w-xl">
              Don't spend hours researching. Tell our AI your budget, vibe, and city, and get a hyper-local, bookable itinerary instantly.
            </p>
            <button 
              onClick={() => setActiveTab('ai-planner')}
              className="bg-white text-indigo-900 px-8 py-4 rounded-xl font-bold text-lg hover:bg-indigo-50 transition shadow-lg flex items-center"
            >
              Try the AI Planner <ArrowRight className="ml-2" />
            </button>
          </div>
          <div className="md:w-1/3 mt-8 md:mt-0 relative z-10 flex justify-center">
             <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-2xl w-full max-w-sm">
                <div className="space-y-4">
                  <div className="h-4 bg-white/20 rounded w-3/4"></div>
                  <div className="h-4 bg-white/20 rounded w-full"></div>
                  <div className="h-4 bg-white/20 rounded w-5/6"></div>
                  <div className="mt-6 flex gap-2">
                    <div className="h-8 bg-indigo-500/50 rounded-lg w-1/3"></div>
                    <div className="h-8 bg-indigo-500/50 rounded-lg w-1/3"></div>
                  </div>
                </div>
             </div>
          </div>
        </div>

      </div>
    </div>
  );
}

// 📧 WIRED NEWSLETTER COMPONENT (CONTACT FORM 7) 📧
function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!email) return;

    setStatus('loading');

    // ⚠️ ============================================================== ⚠️
    // IMPORTANT: Change "YOUR_FORM_ID_HERE" to the actual ID from WordPress!
    const CF7_FORM_ID = 'YOUR_FORM_ID_HERE'; 
    // ⚠️ ============================================================== ⚠️
    
    const apiUrl = `https://admin.canadianlogs.com/wp-json/contact-form-7/v1/contact-forms/${CF7_FORM_ID}/feedback`;

    // CF7 requires data sent as FormData
    const formData = new FormData();
    formData.append('your-email', email);
    
    // THE FIX: We manually inject the hidden tracking tags CF7 requires!
    formData.append('_wpcf7', CF7_FORM_ID);
    formData.append('_wpcf7_unit_tag', `wpcf7-f${CF7_FORM_ID}-p0-o1`);

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.status === 'mail_sent') {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
        setErrorMessage(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setStatus('error');
      setErrorMessage('Network error. Please try again later.');
    }
  };

  return (
    <div className="bg-slate-900 rounded-3xl p-8 md:p-12 text-center shadow-2xl mb-16 relative overflow-hidden border border-slate-800">
      {/* Subtle Background Icon */}
      <div className="absolute top-0 right-0 p-8 opacity-5 pointer-events-none">
        <Mail size={200} />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto">
        <div className="inline-flex items-center space-x-2 bg-slate-800 rounded-full px-4 py-1.5 mb-6 border border-slate-700">
          <Flame size={16} className="text-yellow-400" />
          <span className="text-sm font-bold text-yellow-400 uppercase tracking-wider">The Weekly Deal Drop</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-white mb-4">Never miss a glitch fare.</h2>
        <p className="text-slate-400 text-lg mb-8">
          Join 10,000+ Canadians getting our #1 unadvertised, heavily discounted travel deal sent straight to their inbox every Friday morning.
        </p>

        {status === 'success' ? (
          <div className="bg-green-500/20 border border-green-500/50 rounded-xl p-6 flex flex-col items-center animate-in zoom-in duration-300">
            <CheckCircle2 size={48} className="text-green-400 mb-3" />
            <h3 className="text-xl font-bold text-white mb-1">You're on the list!</h3>
            <p className="text-green-200">Keep an eye on your inbox this Friday for your first exclusive deal.</p>
            <button onClick={() => setStatus('idle')} className="mt-4 text-xs text-green-300 hover:text-white underline">Sign up another email</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                <input
                  type="email"
                  required
                  disabled={status === 'loading'}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address..."
                  className="w-full bg-slate-800 border border-slate-700 text-white rounded-xl py-4 pl-12 pr-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-500 disabled:opacity-50"
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-xl font-bold transition flex items-center justify-center whitespace-nowrap shadow-lg shadow-blue-900/50 disabled:opacity-70"
              >
                {status === 'loading' ? <Loader2 className="animate-spin" size={24} /> : 'Send me Deals'}
              </button>
            </div>
            {status === 'error' && (
              <p className="text-red-400 text-sm mt-2 flex items-center justify-center"><AlertCircle size={16} className="mr-1"/> {errorMessage}</p>
            )}
          </form>
        )}
        <p className="text-slate-500 text-xs mt-4">100% free. No spam. Unsubscribe anytime.</p>
      </div>
    </div>
  );
}


function DestinationsView({ setActiveTab, destinations, loadingPosts, setSelectedPost }) {
  const handleCardClick = (dest) => {
    setSelectedPost(dest);
    setActiveTab('article');
    window.scrollTo(0,0);
  }

  return (
    <div className="animate-in fade-in max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="mb-12">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-4">All Canadian Destinations</h1>
        <p className="text-lg text-slate-600 max-w-2xl">Browse our complete collection of curated local guides, hidden gems, and travel tips across Canada.</p>
      </div>

      <AdBanner />

      {loadingPosts ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
           {[1, 2, 3].map(skeleton => (
              <div key={skeleton} className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden h-96 flex flex-col animate-pulse">
                <div className="bg-slate-200 h-56 w-full"></div>
              </div>
           ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {destinations.map(dest => (
            <div 
              key={dest.id} 
              onClick={() => handleCardClick(dest)}
              className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-xl hover:border-blue-200 transition group cursor-pointer flex flex-col"
            >
              <div className="relative h-56 overflow-hidden shrink-0">
                <img src={dest.image} alt="Featured" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-slate-800 shadow">
                  {dest.category}
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition" dangerouslySetInnerHTML={{ __html: dest.title }}></h3>
                <div className="flex items-center text-sm text-slate-500 mb-4 shrink-0">
                  <Star size={16} className="text-amber-400 fill-amber-400 mr-1" />
                  <span className="font-bold text-slate-700 mr-1">{dest.rating}</span>
                </div>
                <div className="text-slate-600 text-sm line-clamp-3" dangerouslySetInnerHTML={{ __html: dest.description }}></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function AiPlannerView() {
  const [generating, setGenerating] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [destination, setDestination] = useState("Winnipeg, MB");
  const [duration, setDuration] = useState("A Weekend (2-3 days)");
  const [budget, setBudget] = useState("Mid-range");
  const [vibe, setVibe] = useState("Hidden Gems & Local Culture");

  const handleGenerate = async (e) => {
    e.preventDefault();
    setGenerating(true);
    setError(null);
    const apiKey = process.env.REACT_APP_GEMINI_API_KEY;

    if (!apiKey) {
      setError("API Key is missing.");
      setGenerating(false); return;
    }

    const promptText = `Act as a Canadian travel expert. Create a custom itinerary for ${destination}. Duration: ${duration}. Budget: ${budget}. Vibe: ${vibe}. Respond ONLY with a valid JSON object: {"title": "Title", "subtitle": "Subtitle", "days": [{"dayNumber": 1, "theme": "Theme", "activities": [{"time": "10:00 AM", "title": "Act", "desc": "Desc"}]}]}`;

    try {
      const response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${apiKey}`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ contents: [{ parts: [{ text: promptText }] }] })
      });
      const data = await response.json();
      if (data.error) throw new Error(data.error.message);
      let aiText = data.candidates[0].content.parts[0].text.replace(/```json/g, '').replace(/```/g, '').trim();
      setResult(JSON.parse(aiText));
    } catch (err) {
      setError("Oops! The AI got confused. Try again.");
    } finally { setGenerating(false); }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 animate-in fade-in">
      <div className="text-center mb-10">
        <Sparkles size={32} className="inline-block text-indigo-600 bg-indigo-100 p-2 rounded-xl mb-4" />
        <h1 className="text-4xl font-extrabold text-slate-900">AI Trip Planner</h1>
        <p className="text-slate-500 mt-2">Generate a hyper-local itinerary using live AI.</p>
      </div>

      {!result && !generating && (
        <form onSubmit={handleGenerate} className="bg-white p-8 rounded-3xl shadow-xl border space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div><label className="block text-sm font-bold mb-2">Destination</label><input required type="text" value={destination} onChange={e => setDestination(e.target.value)} className="w-full bg-slate-50 border rounded-xl px-4 py-3" /></div>
            <div><label className="block text-sm font-bold mb-2">Duration</label><select value={duration} onChange={e => setDuration(e.target.value)} className="w-full bg-slate-50 border rounded-xl px-4 py-3"><option>A Weekend (2-3 days)</option><option>Full Week (7 days)</option></select></div>
            <div><label className="block text-sm font-bold mb-2">Budget</label><select value={budget} onChange={e => setBudget(e.target.value)} className="w-full bg-slate-50 border rounded-xl px-4 py-3"><option>Shoestring (Hostels)</option><option>Mid-range</option><option>Luxury</option></select></div>
            <div><label className="block text-sm font-bold mb-2">Vibe</label><select value={vibe} onChange={e => setVibe(e.target.value)} className="w-full bg-slate-50 border rounded-xl px-4 py-3"><option>Hidden Gems</option><option>Outdoors</option></select></div>
          </div>
          <button type="submit" className="w-full bg-indigo-600 text-white font-bold py-4 rounded-xl flex justify-center items-center"><Sparkles className="mr-2" /> Generate Itinerary</button>
        </form>
      )}

      {generating && (
        <div className="bg-white p-12 rounded-3xl text-center"><Compass size={48} className="animate-spin text-indigo-500 mx-auto mb-4" /><h3 className="text-2xl font-bold">Curating local secrets...</h3></div>
      )}

      {result && !generating && (
        <div className="bg-white rounded-3xl shadow-xl border overflow-hidden">
          <div className="bg-indigo-600 p-8 text-white relative">
            <button onClick={() => setResult(null)} className="absolute top-4 right-4 bg-indigo-700 p-2 rounded-full"><X size={20} /></button>
            <h2 className="text-3xl font-bold">{result.title}</h2>
            <p className="text-indigo-100 mt-2">{result.subtitle}</p>
          </div>
          <div className="p-8 space-y-8">
            {result.days.map((day, idx) => (
              <div key={idx} className="relative pl-8 border-l-2 border-indigo-100 pb-4">
                <div className="absolute -left-4 top-0 bg-indigo-600 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold">{day.dayNumber}</div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">{day.theme}</h3>
                <div className="space-y-4">
                  {day.activities.map((act, actIdx) => (
                    <div key={actIdx} className="bg-slate-50 rounded-xl p-4 border flex items-start">
                      <div className="bg-white p-2 rounded-lg text-indigo-600 mr-4 border"><MapPin size={20} /></div>
                      <div className="flex-1"><div className="flex justify-between items-baseline mb-1"><h4 className="font-bold">{act.title}</h4><span className="text-xs font-bold text-indigo-500">{act.time}</span></div><p className="text-sm text-slate-600">{act.desc}</p></div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function Footer({ setActiveTab }) {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-8 text-sm">
        <div className="col-span-1 md:col-span-2">
          <div className="flex items-center space-x-2 text-white mb-4"><Snowflake size={24} className="text-blue-500" /><span className="text-xl font-bold">Canadian Logs</span></div>
          <p className="max-w-sm">The local-first travel platform for Canada. Authentic itineraries and tools to plan your perfect trip.</p>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4">Explore</h4>
          <ul className="space-y-2">
            <li><button onClick={() => {setActiveTab('destinations'); window.scrollTo(0,0);}} className="hover:text-white transition">City Guides</button></li>
            <li><button onClick={() => {setActiveTab('destinations'); window.scrollTo(0,0);}} className="hover:text-white transition">Winter Travel</button></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4">Partner</h4>
          <ul className="space-y-2">
            <li><button onClick={() => {setActiveTab('home'); window.scrollTo(0,0);}} className="hover:text-white transition">Affiliate Program</button></li>
            <li><button onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition">Sponsorships</button></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}